class AddressDrawer extends HTMLElement {
  constructor() {
    super();

    this.querySelector("#AddressDrawer-Overlay")?.addEventListener(
      "click",
      this.close.bind(this)
    );

    this.addEventListener("keyup", (e) => {
      if (e.code === "Escape") this.close();
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    window.OpusNoATC = true;
    this.classList.add("animate", "active");
    const mode = this.getAttribute("mode") || "create";
    setTimeout(() => {
      const focusElement = this.querySelector(".drawer__inner");
      trapFocus(this, focusElement);
    });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    window.OpusNoATC = false;
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("address-drawer", AddressDrawer);
